import { Copy, MoveUpRight, Phone, Timer } from "lucide-react";
import { toast } from "sonner";

export default function ContactSection({ openBooking }) {
  const copyEmail = async () => {
    await navigator.clipboard.writeText("tybradigital@gmail.com");
    toast.success("Tybra email copied to clipboard");
  };

  return (
    <section id="contact" data-testid="contact-section" className="section-shell pb-24 pt-8 sm:pb-32">
      <div className="relative overflow-hidden rounded-[2rem] border border-cyan-300/25 bg-[#0F0F17] p-8 shadow-[0_0_120px_rgba(0,240,255,0.12)] sm:p-12 lg:p-16">
        <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-cyan-300/15 blur-[90px]" aria-hidden="true" />
        <div className="relative grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-end">
          <div>
            <p data-testid="contact-eyebrow" className="eyebrow">Start / project signal</p>
            <h2 data-testid="contact-heading" className="mt-5 font-display text-4xl font-extrabold uppercase leading-[0.92] tracking-[-0.06em] text-white sm:text-6xl lg:text-7xl">Make the next version undeniable.</h2>
            <p data-testid="contact-description" className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">Tell Tybra what you are building, what is not working, or what needs to exist next. You will get a clear recommendation and next step.</p>
          </div>
          <div className="flex flex-col gap-4">
            <button data-testid="contact-book-call-button" onClick={() => openBooking("New website")} className="cyan-button rounded-full px-8 py-5 font-mono text-xs font-bold uppercase tracking-[0.22em]">
              Book a call <MoveUpRight className="h-4 w-4" />
            </button>
            <button data-testid="copy-email-button" onClick={copyEmail} className="outline-button rounded-full px-8 py-5 font-mono text-xs uppercase tracking-[0.22em]">
              tybradigital@gmail.com <Copy className="h-4 w-4" />
            </button>
            <a data-testid="phone-contact-link" href="tel:+14793263322" aria-label="Call Tybra Digital at 479-326-3322" className="outline-button rounded-full px-8 py-5 font-mono text-xs uppercase tracking-[0.22em]">
              Call <Phone className="h-4 w-4" />
            </a>
            <div data-testid="response-time-badge" className="flex items-center justify-center gap-2 rounded-full border border-white/10 px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500"><Timer className="h-4 w-4 text-[#CCFF00]" />Responds within 24 hours</div>
          </div>
        </div>
      </div>
    </section>
  );
}
